import { useMemo } from 'react'

export const useRequestId = (deps = []) => {
  const [requestId] = useMemo(() => [crypto.randomUUID()], [...deps])
  return requestId
}
